import { all, takeEvery, takeLatest, put, fork } from 'redux-saga/effects';

import axios from './initialize'
import { Modal } from 'antd';
import {CheckCircleFilled,ExclamationCircleOutlined} from  '@ant-design/icons';

import { GET_ACCOUNT_USER_LIST,SEND_INVITATION_MAIL,ACCEPT_INVITATION,GET_NOTIFICATION,CLEAR_NOTIFICATION,READ_NOTIFICATION, GET_INVITE_ACCOUNT_USER_LIST, REMOVE_ACCOUNT_USER, RESTORE_USER_TO_ACCOUNT, DELETE_NOTIFICATIONS, DELETE_NOTIFICATION, RESEND_INVITATION, DELETE_USER_INVITATION, GET_ALL_USER_LIST, SAVE_ACCOUNT_USER} from "redux/constants/user";

import { accountUserList, showAccountUserMessage,notificatonList,inviteAccountUserList, allUserList, showLoading } from "redux/actions/user";
import { showAuthMessage} from "redux/actions/Auth";

import { API, API_BASE_URL, APP_PREFIX_PATH, AUTH_PREFIX_PATH, MANAGE_PREPIX_PATH, USERS_PREPIX_PATH, VERSION } from 'configs/AppConfig';
import {
	AUTH_TOKEN,
} from '../constants/Auth';
import { t } from 'i18next';
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";
import {GET_ACCOUNT_LIST } from  "redux/constants/account";

export function* getAccountUserList(){
    yield takeLatest (GET_ACCOUNT_USER_LIST, function*  ({requestData}){
	    const {query, sorter,pagination,type,userType} = requestData;
	   const accountId = localStorage.getItem("accountId");
	  const headers = {Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`}
	//  var tokenHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN), 'Content-Type': 'application/json' });
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
	    "accountId": accountId,
		accountUserId: localStorage.getItem("accountUserId")}
	  };
		try {
		const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/account-users?accountId=${accountId}&userType=${userType}&type=${type}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_account_user_${type}_list`,
						event: 'click',
						message: `${res?.data?.totalElements} results found for keyword=${query} and account=${accountId}`,
						status: `${type} account user list retrieve successfully `,
						action: `Search ${type} account user list`,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_account_user_${type}_list`,
					event: 'click',
					message: `${res?.data?.totalElements} results found for account=${accountId}`,
					status: `${type} account user list retrieve successfully `,
					action: `Clicked get ${type} account user list `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(accountUserList(res.data));
			} else {
				yield put(showAccountUserMessage(res));
			}
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_account_user_${type}_list`,
					event: 'click',
					message: `0 results found for keyword=${query} and account=${accountId}`,
					status: `Failed to retrieve ${type} account user list`,
					action: `Search ${type} account user list`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_account_user_${type}_list`,
				event: 'click',
				message: `0 results found for account=${accountId}`,
				status: `Failed to retrieve ${type} account user list`,
				action: `Clicked get ${type} account user list `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err?.response?.status===401 || err?.response?.data?.status===401){
				yield put(showAccountUserMessage(err.response));
			}
			yield put(showAccountUserMessage(err.response));
		}
    })
}

export function* updateAccountUser(){
    yield takeEvery (RESTORE_USER_TO_ACCOUNT, function*  ({requestData}){
		const {query, sorter,pagination,accountUser,reStore,type}=requestData;
		const {accountId,userId,status,userType} = accountUser;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.put(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/account-users?accountId=${accountId}&userId=${userId}`,accountUser,
		config);
			if (res.status===200) {
				const traceUpdate = reStore?"restored":`user type updated to ${userType}`
				const traceObj ={
					type: `update_account_user`,
					event: 'click',
					message: `Account user ${traceUpdate} for userId=${userId} and accountId=${accountId}`,
					status: `Account user ${traceUpdate}`,
					action: `Clicked update account user`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				const msg =status=='INACTIVE'?t("impaqx.adminApp.userRestored"):"User status updated";
				Modal.success({
					title: msg,
					icon: <CheckCircleFilled />,
					okText: "Close",
					onOk() {	
					}
				});
				const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/account-users?accountId=${accountUser.accountId}&userType=${localStorage.getItem("userType")}&type=${type}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		 config);
			 if (res.status===200) {
				 yield put(accountUserList(res.data));
			 } 
			} 
		} catch (err) {
			const traceObj ={
				type: `update_account_user`,
				event: 'click',
				message: `Failed to update account user For userId=${userId} and accountId=${accountId}`,
				status: `Failed to update account user  `,
				action: `Clicked update account user`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			console.log(err);
			if(err?.response?.status===401 || err?.response?.data?.status===401){
				yield put(showAccountUserMessage(err.response));
			}
			yield put(showAccountUserMessage(err.response));
		}
    })
}

export function* saveAccountUser(){
    yield takeEvery (SAVE_ACCOUNT_USER, function*  ({payload}){
		const {query, sorter,pagination,role,username,userType,roleName} = payload;
		  try {
			const config = {
				headers: {
				  "Content-Type": "application/json",
				  "Access-Control-Allow-Origin": "*",
				  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
				  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  accountId: localStorage.getItem("accountId"),
				  accountUserId: localStorage.getItem("accountUserId"),
				  "roleName" : roleName,
				  "accountName":localStorage.getItem("businessName"),
				  "username": localStorage.getItem("username")
				},
			  };
			var data={};
			data["toEmail"] = username;
			data["fromAccountId"] = localStorage.getItem("accountId");
			data["fromUserId"] = localStorage.getItem("userId");
			data["roleId"] = role;
			data["roleName"]=roleName;
			data["userType"]=userType;
			data["appRoles"]=JSON.stringify(payload?.appRoles);
		const res = yield  axios.put(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/account-users-roles?accountId=${localStorage.getItem("accountId")}&userId=${localStorage.getItem("userId")}`,data,
		config);
			if (res.status===200) {
				const traceObj ={
					type: `update_account_user`,
					event: 'click',
					message: `Account user updadted for userId=${localStorage.getItem("userId")} and accountId=${localStorage.getItem("accountId")}`,
					status: `Account user updated`,
					action: `Clicked update account user`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				Modal.success({
					title: "User updated successfully",
					icon: <CheckCircleFilled />,
					okText: "Close",
					onOk() {	
					}
				});
				const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/account-users?accountId=${localStorage.getItem("accountId")}&userType=${localStorage.getItem("userType")}&type=activeUsers&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		 config);
			 if (res.status===200) {
				 yield put(accountUserList(res.data));
			 } 
			} 
		} catch (err) {
			const traceObj ={
				type: `update_account_user`,
				event: 'click',
				message: `Failed to update account user For userId=${localStorage.getItem("userId")} and accountId=${localStorage.getItem("accountId")}`,
				status: `Failed to update account user  `,
				action: `Clicked update account user`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			console.log(err);
			if(err?.response?.status===401 || err?.response?.data?.status===401){
				yield put(showAccountUserMessage(err.response));
			}
			yield put(showAccountUserMessage(err.response));
		}
    })
}

export function* getInviteAccountUserList(){
    yield takeLatest (GET_INVITE_ACCOUNT_USER_LIST, function*  ({requestData}){
	    const {query, sorter,pagination,type,userType} = requestData;
	   const accountId = localStorage.getItem("accountId");
	  const headers = {Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`}
	//  var tokenHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN), 'Content-Type': 'application/json' });
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/invite-users?accountId=${accountId}&type=${type}&userType=${userType}
		&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_invite_account_user_list`,
						event: 'click',
						message: `${res?.data?.totalElements} results found for keyword=${query} and accountId=${accountId}`,
						status: `Retrieve invite account user list successfully `,
						action: `Search invite account user list`,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_invite_account_user_list`,
					event: 'click',
					message: `${res?.data?.totalElements} results found for accountId=${accountId}`,
					status: `Retrieve invite account user list successfully `,
					action: `Clicked invite account user list`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(inviteAccountUserList(res.data));
			} 
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_invite_account_user_list`,
					event: 'click',
					message: `0 results found for keyword=${query} and accountId=${accountId}`,
					status: `Failed to retrieve invite account user list`,
					action: `Search invite account user list`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_invite_account_user_list`,
				event: 'click',
				message: `0 results found for accountId=${accountId}`,
				status: `Failed to retrieve invite account user list`,
				action: `Clicked invite account user list`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err?.response?.status===401 || err?.response?.data?.status===401){
				yield put(showAccountUserMessage(err.response));
			}
			yield put(showAccountUserMessage(err.response));
		}
    })
}

export function* sendInvitationEmail() {
	yield takeEvery(SEND_INVITATION_MAIL, function* ({payload}) {
		const {query, sorter,pagination,role,values,userType} = payload;
		  try {
			const config = {
				headers: {
				  "Content-Type": "application/json",
				  "Access-Control-Allow-Origin": "*",
				  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
				  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  accountId: localStorage.getItem("accountId"),
				  accountUserId: localStorage.getItem("accountUserId")
				},
			  };
			var data={};
			data["toEmail"] = values.username;
			data["fromAccountId"] = localStorage.getItem("accountId");
			data["fromUserId"] = localStorage.getItem("userId");
			data["roleId"] = role;
			data["userType"]=userType;
			data["appRoles"]=JSON.stringify(payload?.appRoles);
		  const res = yield  axios.post(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/invite-user`, data,config);
			  if (res.status===200) {		
				const traceObj ={
					type: `send_invite_users`,
					event: 'click',
					message: `Sent invitation to emailId(s)=${values?.username}`,
					status: "Sent invitation to emailId(s)",
					action: `Clicked to send invitation`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				  const page = pagination?.current ? pagination.current - 1 : 0;
				  const size = pagination?.pageSize || 10;
				  const listUserType = userType || localStorage.getItem("userType");
				  const response = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/invite-users?accountId=${localStorage.getItem("accountId")}&type=pendingUsers&userType=${listUserType}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${page}&size=${size}`,
		config);
			if (response.status===200) {
				yield put(inviteAccountUserList(response.data));
			} 
			yield put(showAccountUserMessage(res));
			  } else {
				  yield put(showAccountUserMessage(res));
			  }
		  } catch (err) {
			const traceObj ={
				type: `send_invite_users`,
				event: 'click',
				message: `Failed to sent invitation to emailId(s)=${values?.username}`,
				status: `Failed to sent invitation to emailId(s)`,
				action: `Clicked to send invitation`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			  console.log(err.response);
			  yield put(showAccountUserMessage(err.response));
		  }
	  });
  }

  export function* removeAccountUser() {
	yield takeEvery(REMOVE_ACCOUNT_USER, function* ({payload}) {
		  try {
			const {accountUser,query, sorter,pagination,type,userType} = payload;

			const accountId = localStorage.getItem("accountId");
			const id= accountUser?.accountUserId;
			const config = {
				headers: {
				  "Content-Type": "application/json",
				  "Access-Control-Allow-Origin": "*",
				  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
				  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  accountId: accountId,
				  accountUserId: localStorage.getItem("accountUserId")
				},
			  };
			payload["toEmail"] = payload.username;
			payload["fromAccountId"] = localStorage.getItem("accountId");
			payload["fromUserId"] = localStorage.getItem("userId");
		  const res = yield  axios.delete(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/${id}`,config);
			  if (res.status===200) {	
				const traceObj ={
					type: `remove_account_user`,
					event: 'click',
					message: `Account user of userId=${localStorage.getItem("userId")} removed from accountId=${localStorage.getItem("accountId")}`,
					status: `Account user removed successfully `,
					action: `Clicked remove account user`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});	
				Modal.success({
					title: t("impaqx.adminApp.userRemoveMessage"),
					icon: <CheckCircleFilled />,
					okText: "Close",
					onOk() {	
					}
				});	
				const response = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/account-users?accountId=${accountId}&userType=${userType}&type=${type}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		        config);
			if (response.status===200) {
				yield put(accountUserList(response.data));
			} 
				 // yield put(showAccountUserMessage(res));
			  } else {
				  yield put(showAccountUserMessage(res));
			  }
		  } catch (err) {
			const traceObj ={
				type: `remove_account_user`,
				event: 'click',
				message: `Failed to remove account user of userId=${localStorage.getItem("userId")} removed from accountId=${localStorage.getItem("accountId")}`,
				status: `Failed to remove Account User`,
				action: `Clicked remove account user`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});	
			  console.log(err.response);
			  yield put(showAccountUserMessage(err.response));
		  }
	  });
  }

  export function* deleteUserInvitation() {
	yield takeEvery(DELETE_USER_INVITATION, function* ({payload}) {
		  try {
			const {userInvitation,query, sorter,pagination,type,userType} = payload;

			const accountId = localStorage.getItem("accountId");
			const id= userInvitation?.id;
			const config = {
				headers: {
				  "Content-Type": "application/json",
				  "Access-Control-Allow-Origin": "*",
				  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
				  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
				  accountId: accountId,
				  accountUserId: localStorage.getItem("accountUserId")
				},
			  };
		  const res = yield  axios.delete(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/userinvitation/${id}`,config);
			  if (res.status===200) {
				const traceObj ={
					type: `delete_user_invitation`,
					event: 'click',
					message: `User invitation deleted for id=${id}`,
					status: `User invitation deleted successfully `,
					action: `Clicked delete user invitation `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});	
				Modal.success({
					title: t("impaqx.adminApp.deleteUserInvitationSuccessMessage"),
					icon: <CheckCircleFilled />,
					okText: "Close",
					onOk() {	
					}
				});	
					const response = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/invite-users?accountId=${accountId}&type=${type}&userType=${userType}
					&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current-1}&size=${pagination?.pageSize}`,
					config);
						if (response.status===200) {
							yield put(inviteAccountUserList(response.data));
						} 
			  } else {
				  yield put(showAccountUserMessage(res));
			  }
		  } catch (err) {
			const traceObj ={
				type: `delete_user_invitation`,
				event: 'click',
				message: `Failed to delete user invitation id=${payload?.userInvitation?.id}`,
				status: `Failed to delete user invitation`,
				action: `Clicked delete user invitation `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});	
			  console.log(err.response);
			  yield put(showAccountUserMessage(err.response));
		  }
	  });
  }


  export function* acceptInvitations(){
    yield takeEvery (ACCEPT_INVITATION, function*  ({payload}){
	    const { key,nId } = payload;
	  const headers = {Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`}
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.put(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${AUTH_PREFIX_PATH}/accept-invitation?key=${key}`,
		config);
			if (res.status===200) {
				const traceObj ={
					type: `accept_user_invitation`,
					event: 'click',
					message: `User invitation accepted for key=${key}`,
					status: `User invitation accepted successfully `,
					action: `Clicked accept user invitation `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});	
				if(res.data.userPresent){
					sessionStorage.setItem("activationMessage",t("impaqx.adminApp.acceptInvitationMessage"));
					sessionStorage.setItem("userPresent",res.data.userPresent);
					sessionStorage.setItem("email",res.data.email);
					sessionStorage.setItem("accountName",res?.data?.accountName);
					if(localStorage.getItem("userId")==res.data.accountUser.userId){
							Modal.success({
								title: t("impaqx.adminApp.acceptInvitationMessage").replace("email123",res.data.email).replace("account1234",res?.data?.accountName),
								icon: <CheckCircleFilled />,
								okText: "Close",
								//cancelText: 'Cancel',
								onOk() {	
									window.location.replace("/admin/app/pages/account-list?mode=view-all");
								}
							});
					}else{
						window.location.replace("/admin/auth/login");
					}
							//deleteApp(id);
				//}   
						
				}else{
					sessionStorage.setItem("activationMessage",t("impaqx.adminApp.acceptInvitationRegMessage"));
					sessionStorage.setItem("userPresent",res?.data?.userPresent);
					sessionStorage.setItem("email",res?.data?.email);
					sessionStorage.setItem("accountName",res?.data?.accountName);
                    window.location.replace(`/admin/auth/register?key=${res.data.key}&nId=${nId}`);
				}
			} 
		} catch (err) {
			console.log(err);
			const traceObj ={
				type: `accept_user_invitation`,
				event: 'click',
				message: `Failed to accept user invitation for key=${key}`,
				status: `Failed to accept user invitation`,
				action: `Clicked to accept user invitation `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});	
			if(err?.response?.status===400){
				sessionStorage.setItem("activationerrorMessage",err?.response?.data?.message);
				sessionStorage.setItem("userPresent",err?.response?.data?.userPresent);
				sessionStorage.setItem("email",err?.response?.data?.email);
				if(localStorage.getItem("userId")){
				  if(err?.response?.data?.message.includes('expired')){
                    Modal.info({
						title: err?.response?.data?.message,
						icon: <ExclamationCircleOutlined />,
						okText: "Yes",
						cancelText: 'No',
						okCancel:true,
						onOk() {	
							axios.put(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${AUTH_PREFIX_PATH}/resend-invitation-request?key=${key}`,
							config).then(resendInviteResponse=> {
									Modal.info({
										title: t("impaqx.adminApp.invitationRequestMessage"),
										icon: <ExclamationCircleOutlined />,
										okText: "Yes",
										onOk() {
											window.location.replace("/admin/app/pages/account-list?mode=view-all");
										}
									});
								}).catch(error => {
								})	
						},
						onCancel() {
							window.location.replace("/admin/app/pages/account-list?mode=view-all");
						}
					})
				  }else{
					Modal.info({
						title: t("impaqx.adminApp.activationerrorMessage"),
						icon: <ExclamationCircleOutlined />,
						okText: "Close",
						onOk() {	
						  window.location.replace("/admin/app/pages/account-list?mode=view-all");
						}
					})
				  }
				 }else{
					window.location.replace("/admin/auth/login");
				}
			}
			if(err?.response?.status===401 || err?.response?.data?.status===401){
				yield put(showAccountUserMessage(err.response));
			}
			//yield put(showAccountUserMessage(err.response));
		}
    })
}

export function* getNotificationList(){
    yield takeEvery (GET_NOTIFICATION, function*  ({requestData}){
	//   const accountId = localStorage.getItem("accountId");
	   const userId = localStorage.getItem("userId");
	  const headers = {Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`}
	//  var tokenHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN), 'Content-Type': 'application/json' });
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/notifications?userId=${userId}`,config);
			if (res.status===200) {
				// const traceObj ={
				// 	type: `get_notification_list`,
				// 	event: 'click',
				// 	message: `${res?.data?.totalElements} results found`,
				// 	status: `Notification List Retrieve successfully `,
				// 	action: `Clicked get notification list `,
				// 	referer_action_id: localStorage.getItem("referer_action_id"),
				// 	trackId: uuidv4(),
				// 	user_session: sessionStorage.getItem("user_session")
				//   };
				//   localStorage.setItem("referer_action_id",traceObj.trackId);
				//   trace({"traceObj":traceObj});
				yield put(notificatonList(res.data));
			} 
		} catch (err) {
			// const traceObj ={
			// 	type: `get_notification_list`,
			// 	event: 'click',
			// 	message: `0 results found`,
			// 	status: `Failed To Retrieve Notification List`,
			// 	action: `Clicked get notification list `,
			// 	referer_action_id: localStorage.getItem("referer_action_id"),
			// 	trackId: uuidv4(),
			// 	user_session: sessionStorage.getItem("user_session")
			//   };
			//   localStorage.setItem("referer_action_id",traceObj.trackId);
			//   trace({"traceObj":traceObj});
			console.log(err);
			if(err?.response?.status===401 || err?.response?.data?.status===401){
				yield put(showAccountUserMessage(err.response));
			}
			yield put(showAccountUserMessage(err.response));
		}
    })
}

export function* clearNotificationData() {
	yield takeEvery(CLEAR_NOTIFICATION, function* ({payload}) {
		const userId = localStorage.getItem("userId");
		const config = {
			headers: {
			  "Content-Type": "application/json",
			  "Access-Control-Allow-Origin": "*",
			  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
			  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			  accountId: localStorage.getItem("accountId"),
			  accountUserId: localStorage.getItem("accountUserId")
			},
		  };
		  try {
		  const res = yield  axios.put(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/clear-notification?userId=${userId}`,config);
			  if (res.status===200) {	
				const traceObj ={
					type: `clear_notification_data`,
					event: 'click',
					message: `Notification clear successfully  for userId=${userId}`,
					status: `Notification clear successfully `,
					action: `Clicked clear notification data`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});	
				const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/notifications?userId=${userId}`,config);
					if (res.status===200) {
						yield put(notificatonList(res.data));
					} 
				 // yield put(showAccountUserMessage(res));
			  } else {
				  yield put(showAccountUserMessage(res));
			  }
		  } catch (err) {
			const traceObj ={
				type: `clear_notification_data`,
				event: 'click',
				message: `Failed to clear notification for userId=${userId}`,
				status: `Failed to clear notification`,
				action: `Clicked clear notification data `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});	
			  console.log(err.response);
			  yield put(showAccountUserMessage(err.response));
		  }
	  });
  }

  export function* readNotificationData() {
	yield takeEvery(READ_NOTIFICATION, function* ({payload}) {
		const userId = localStorage.getItem("userId");
		const config = {
			headers: {
			  "Content-Type": "application/json",
			  "Access-Control-Allow-Origin": "*",
			  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
			  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			  accountId: localStorage.getItem("accountId"),
			  accountUserId: localStorage.getItem("accountUserId")
			},
		  };
		  try {
		  const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${AUTH_PREFIX_PATH}/read-notification?notificationId=${payload.id}`,config);
			  if (res.status===200) {	
				const traceObj ={
					type: `read_notification_data`,
					event: 'click',
					message: `Notification read successfully  for notificationId=${payload.id}`,
					status: `Notification read successfully  `,
					action: `Clicked read notification data `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});		
				const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/notifications?userId=${userId}`,config);
					if (res.status===200) {
						yield put(notificatonList(res.data));
					} 
				  yield put(showAccountUserMessage(res));
			  } else {
				  yield put(showAccountUserMessage(res));
			  }
		  } catch (err) {
			const traceObj ={
				type: `read_notification_data`,
				event: 'click',
				message: `Failed to read notification for notificationId=${payload.id}`,
				status: `Failed to read notification `,
				action: `Clicked read notification data `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});	
			  console.log(err.response);
			  yield put(showAccountUserMessage(err.response));
		  }
	  });
  }

  export function* deleteNotification() {
	yield takeEvery(DELETE_NOTIFICATION, function* ({payload}) {
		const {id} = payload;
		const userId = localStorage.getItem("userId");
		const config = {
			headers: {
			  "Content-Type": "application/json",
			  "Access-Control-Allow-Origin": "*",
			  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
			  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			  accountId: localStorage.getItem("accountId"),
			  accountUserId: localStorage.getItem("accountUserId")
			},
		  };
		  try {
		  const res = yield  axios.delete(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/delete-notification?notificationId=${id}`,config);
			  if (res.status===200) {
				const traceObj ={
					type: `delete_notification`,
					event: 'click',
					message: `Notification deleted successfully  for notificationId=${id}`,
					status: `Notification deleted successfully `,
					action: `Clicked delete notification `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				Modal.info({
					title: "Notification deleted successfully",
					icon: <CheckCircleFilled />,
					okText: "Close",
					//cancelText: 'Cancel',
					onOk() {	
					}
				})	
				const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/notifications?userId=${userId}`,config);
					if (res.status===200) {	
						yield put(notificatonList(res.data));
					} 
				 // yield put(showAccountUserMessage(res));
			  } else {
				  yield put(showAccountUserMessage(res));
			  }
		  } catch (err) {
			const traceObj ={
				type: `delete_notification`,
				event: 'click',
				message: `Failed to delete notification for notificationId=${id}`,
				status: `Failed to delete notification`,
				action: `Clicked delete notification `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});	
			  console.log(err.response);
			  yield put(showAccountUserMessage(err.response));
		  }
	  });
  }

  export function* deleteNotifications() {
	yield takeEvery(DELETE_NOTIFICATIONS, function* ({payload}) {
		const userId = localStorage.getItem("userId");
		const config = {
			headers: {
			  "Content-Type": "application/json",
			  "Access-Control-Allow-Origin": "*",
			  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
			  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
			  accountId: localStorage.getItem("accountId"),
			  accountUserId: localStorage.getItem("accountUserId")
			},
		  };
		  try {
		  const res = yield  axios.delete(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/delete-notifications?userId=${userId}`,config);
			  if (res.status===200) {
				const traceObj ={
					type: `delete_notifications`,
					event: 'click',
					message: `Notifications deleted successfully  for userId=${userId}`,
					status: `Notifications deleted successfully `,
					action: `Clicked delete notifications `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});	
				Modal.info({
					title: "Notifications deleted successfully",
					icon: <CheckCircleFilled />,
					okText: "Close",
					//cancelText: 'Cancel',
					onOk() {	
					}
				})	
				const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/notifications?userId=${userId}`,config);
					if (res.status===200) {
						yield put(notificatonList(res.data));
					} 
				 // yield put(showAccountUserMessage(res));
			  } else {
				  yield put(showAccountUserMessage(res));
			  }
		  } catch (err) {
			const traceObj ={
				type: `delete_notifications`,
				event: 'click',
				message: `Failed to delete notifications for userId=${userId}`,
				status: `Failed to delete notifications`,
				action: `Clicked delete notifications `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});	
			  console.log(err.response);
			  yield put(showAccountUserMessage(err.response));
		  }
	  });
  }

  export function* resendInvitation(){
    yield takeEvery (RESEND_INVITATION, function*  ({payload}){
	    const { key,nId } = payload;
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
		accountUserId: localStorage.getItem("accountUserId") }
	  };
		try {
		const res = yield  axios.put(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${AUTH_PREFIX_PATH}/resend-invitation?key=${key}`,
		config);
			if (res.status===200) {
				const traceObj ={
					type: `send_invite_users`,
					event: 'click',
					message: `Resent invitation of key=${key}`,
					status: `Resent invitation to emailId(s)`,
					action: `Clicked to resend invitation`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				Modal.success({
					title: res.data,
					icon: <CheckCircleFilled />,
					okText: "Close",
					//cancelText: 'Cancel',
					onOk() {	
						if(localStorage.getItem("userId")!==null)
						window.location.replace("/admin/app/pages/account-list?mode=view-all");
					}
				});
			} 
		} catch (err) {
			const traceObj ={
				type: `send_invite_users`,
				event: 'click',
				message: `Failed to resend invitation to key=${key}`,
				status: `Failed to resend invitation to emailId(s)`,
				action: `Clicked to resend invitation`,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			console.log(err);
			yield put(showAccountUserMessage(err.response));
		}
    })
}

export function* getAllUserList(){
    yield takeEvery (GET_ALL_USER_LIST, function*  ({requestData}){
	    const {query, sorter,pagination,type,userType,accountId} = requestData;
	//    const accountId = localStorage.getItem("accountId");
	  const headers = {Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`}
	//  var tokenHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN), 'Content-Type': 'application/json' });
const config = {
		headers: { "Content-Type": 'application/json',"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",Authorization : `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
	    "accountId": accountId,
		accountUserId: localStorage.getItem("accountUserId")}
	  };
		try {
		const res = yield  axios.get(`${API_BASE_URL}${MANAGE_PREPIX_PATH}${APP_PREFIX_PATH}/account-user/users?accountId=${accountId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&
		page=${pagination?.current-1}&size=${pagination?.pageSize}`,
		config);
			if (res.status===200) {
				if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_user_list`,
						event: 'click',
						message: `Keyword=${query}`,
						status: `User List Retrieve successfully `,
						action: `Search User List`,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
				  const traceObj ={
					type: `get_all_user_list`,
					event: 'click',
					message: `${res?.data?.totalElements} results found`,
					status: `User List Retrieve successfully `,
					action: `Clicked get user list `,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}
				yield put(allUserList(res.data));
			} 
		} catch (err) {
			if(query!==undefined && query!==""){
				const traceObj ={
					type: `search_user_list`,
					event: 'click',
					message: `Keyword=${query}`,
					status: `Failed To Retrieve User List`,
					action: `Search User List`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
				}else{
			  const traceObj ={
				type: `get_all_user_list`,
				event: 'click',
				message: `0 results found`,
				status: `Failed To Retrieve User List`,
				action: `Clicked get user list `,
				referer_action_id: localStorage.getItem("referer_action_id"),
				trackId: uuidv4(),
				user_session: sessionStorage.getItem("user_session")
			  };
			  localStorage.setItem("referer_action_id",traceObj.trackId);
			  trace({"traceObj":traceObj});
			}
			console.log(err);
			if(err?.response?.status===401 || err?.response?.data?.status===401){
				yield put(showAccountUserMessage(err.response));
			}
			yield put(showAccountUserMessage(err.response));
		}
    })
}

export default function* rootSaga(){
    yield all([
		  fork(getAccountUserList),
		  fork(getInviteAccountUserList),
		  fork(sendInvitationEmail),
		  fork(acceptInvitations),
		  fork(getNotificationList),
		  fork(clearNotificationData),
		  fork(readNotificationData),
		  fork(removeAccountUser),
		  fork(deleteUserInvitation),
		  fork(updateAccountUser),
		  fork(saveAccountUser),
		  fork(deleteNotification),
		  fork(deleteNotifications),
		  fork(resendInvitation),
		  fork(getAllUserList)
    ])
    
}